import React from 'react';
import { Facebook, Instagram, Twitter } from 'lucide-react';
export function Footer() {
  return <footer className="bg-card border-t border-border pt-16 pb-8" data-id="element-98">
      <div className="container mx-auto px-4" data-id="element-99">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-100">
          {/* Brand */}
          <div className="space-y-4" data-id="element-101">
            <h3 className="font-serif text-2xl font-bold text-foreground" data-id="element-102">
              The Old Mill
            </h3>
            <p className="text-muted-foreground text-sm leading-relaxed" data-id="element-103">
              Traditional Irish food in the heart of Temple Bar. Experience the
              warmth of Irish hospitality with every meal.
            </p>
            <div className="flex items-center gap-4 pt-2" data-id="element-104">
              <a href="#" className="text-muted-foreground hover:text-primary transition-colors" data-id="element-105">
                <Facebook className="w-5 h-5" data-id="element-106" />
              </a>
              <a href="#" className="text-muted-foreground hover:text-primary transition-colors" data-id="element-107">
                <Instagram className="w-5 h-5" data-id="element-108" />
              </a>
              <a href="#" className="text-muted-foreground hover:text-primary transition-colors" data-id="element-109">
                <Twitter className="w-5 h-5" data-id="element-110" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4" data-id="element-111">
            <h4 className="font-bold text-foreground" data-id="element-112">Quick Links</h4>
            <ul className="space-y-2 text-sm text-muted-foreground" data-id="element-113">
              <li data-id="element-114">
                <a href="#menus" className="hover:text-primary transition-colors" data-id="element-115">
                  Menus
                </a>
              </li>
              <li data-id="element-116">
                <a href="#gallery" className="hover:text-primary transition-colors" data-id="element-117">
                  Gallery
                </a>
              </li>
              <li data-id="element-118">
                <a href="#location" className="hover:text-primary transition-colors" data-id="element-119">
                  Location
                </a>
              </li>
              <li data-id="element-120">
                <a href="#contact" className="hover:text-primary transition-colors" data-id="element-121">
                  Contact Us
                </a>
              </li>
              <li data-id="element-122">
                <a href="https://oldmillrestaurant.ie/" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors" data-id="element-123">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div className="space-y-4" data-id="element-124">
            <h4 className="font-bold text-foreground" data-id="element-125">Opening Hours</h4>
            <ul className="space-y-2 text-sm text-muted-foreground" data-id="element-126">
              <li className="flex justify-between" data-id="element-127">
                <span data-id="element-128">Monday - Sunday</span>
                <span data-id="element-129">09:00 – 22:30</span>
              </li>
            </ul>
            <p className="text-xs text-muted-foreground/60 italic" data-id="element-130">
              Hours may vary on holidays
            </p>
          </div>

          {/* Contact */}
          <div className="space-y-4" data-id="element-131">
            <h4 className="font-bold text-foreground" data-id="element-132">Contact</h4>
            <ul className="space-y-2 text-sm text-muted-foreground" data-id="element-133">
              <li data-id="element-134">
                <a href="tel:+35316719266" className="hover:text-primary transition-colors" data-id="element-135">
                  +353 1 671 9266
                </a>
              </li>
              <li data-id="element-136">
                <a href="mailto:info@oldmillrestaurant.ie" className="hover:text-primary transition-colors" data-id="element-137">
                  info@oldmillrestaurant.ie
                </a>
              </li>
              <li data-id="element-138">
                14 Temple Bar Square,
                <br data-id="element-139" />
                Dublin 2, Ireland
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground" data-id="element-140">
          <p data-id="element-141">© 2026 The Old Mill Restaurant. All rights reserved.</p>
          <p className="flex items-center gap-1" data-id="element-142">
            Built with{' '}
            <span className="font-bold text-primary" data-id="element-143">Magic Patterns</span>
          </p>
        </div>
      </div>
    </footer>;
}